import { EvaporatorDataBM } from '../types/BusinessModel/EvaporatorDataBM';
import { EvaporatorData } from '../types/ViewModel/EvaporatorData';

export class EvaporatorDataFactory {
    public create(data: EvaporatorDataBM): EvaporatorData {
        return new EvaporatorData(data.runningHours, data.production);
    }
    public createBM(data: any): EvaporatorDataBM {
        return {
            runningHours: data.runningHours,
            production: data.production,
        };
    }

    public createList(data: EvaporatorDataBM[]): EvaporatorData[] {
        return data.map((h) => this.create(h));
    }

    public createBMList(data: any[]): EvaporatorDataBM[] {
        return data.map((h) => this.createBM(h));
    }
}
